import s from './full-screen-modal.module.scss'
import { Modal } from '@shared/ui/modal/modal';
import { useFullscreenVideoModal } from '../../model/useFullscreenVideoModal';
import { IconX } from '@tabler/icons-react';
import { ControlBar } from '@entities/appointment/ui/control-bar/control-bar';
import { VideoConference } from '@entities/appointment/ui/video-conference/video-conference';
import { useFullscreenLayout } from '../../model/useFullscreenLayout';
import { AppointmentAudioRenderer } from '@features/appointment/synchronized-audio/ui/appointment-audio-renderer/appointment-audio-renderer';

export const FullscreenVideoModal = () => {
	const {isOpen, close, modalParams} = useFullscreenVideoModal()
	const selectLayout = useFullscreenLayout()

	return <Modal isOpen={isOpen} close={close}
		style={{
			content: {
				padding: '0px'
			}
		}}>
		<div className={s.fullScreenWrapper}>
			<button onClick={() => close()} className={s.closeModalBtn}>
				<IconX size={20}/>
			</button>
			<div data-lk-theme='default'>
				<VideoConference isFocused focusClassName={s.focusLayout} carouselClassName={s.carousel}/>
				<AppointmentAudioRenderer />
				<ControlBar
					isFullscreen={true}
					className={s.controlBar}
					controls={{
						leave: false
					}}
					isTeacher={modalParams?.isTeacher}
					onSelectLayout={selectLayout}
				/>
			</div>
		</div>
	</Modal>
}
